import Vue from "vue";
import axios from 'axios';
import * as Sentry from "@sentry/vue";

import {
  AUTH_LOGOUT,
  USER_REQUEST,
  USER_ERROR,
  USER_SUCCESS,
  API_URL,
  USER_REGISTER,
  AUTH_ERROR,
  SET_NOTIFICATION,
  AUTH_REQUEST, EMAIL_VERIFICATION, SET_PROFILE_DATA, FORGOT_PASSWORD, RESET_PASSWORD, USER_UPDATE, UPDATE_PASSWORD
} from "../constant";

const state = { status: null, profile: null, notification: {type: null, messages: []} };

const getters = {
  userProfile: state => state.profile,
  userProfileStatus: state => state.status,
  notifications: state => state.notification,
};

const actions = {
  [USER_REGISTER]: ({ commit }, data) => {
    commit(AUTH_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });
    return new Promise((resolve, reject) => {
      axios({url: `${API_URL}/auth/local/register`, data, method: 'POST' })
        .then(resp => {
          commit(USER_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['アカウントの登録を完了するには送信されたメールのURLを開いてください。'] });
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
          reject(err);
          Sentry.captureException(err);
        })
    })
  },
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });

    axios({ url: `${API_URL}/users/me` })
      .then(resp => {
        commit(USER_SUCCESS);
        commit(SET_PROFILE_DATA, resp.data);
      })
      .catch(err => {
        commit(USER_ERROR);
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        dispatch(AUTH_LOGOUT);
        Sentry.captureException(err);
      });
  },
  [EMAIL_VERIFICATION]: ({ commit }, data) => {
    commit(USER_REQUEST);
    return new Promise((resolve, reject) => {
      axios({ url: `${API_URL}/auth/send-email-confirmation`, data, method: 'POST' })
        .then(resp => {
          commit(USER_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['パスワードリセットのメールが送信されました、ご確認ください。'] });
          resolve(resp);
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: [err.response.data.message] });
          commit (USER_ERROR);
          reject(err);
          Sentry.captureException(err);
        })
    });
  },
  [FORGOT_PASSWORD]: ({ commit }, data) => {
    commit(USER_REQUEST);
    axios({ url: `${API_URL}/auth/forgot-password`, data, method: 'POST' })
      .then(() => {
        commit(USER_SUCCESS);
        commit(SET_NOTIFICATION,{ type: 'info', messages: ['パスワードリセットのメールが送信されました、ご確認ください。'] });
      })
      .catch(err => {
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        commit (USER_ERROR);
        Sentry.captureException(err);
      });
  },
  [RESET_PASSWORD]: ({ commit }, data) => {
    commit(USER_REQUEST);
    return new Promise((resolve, reject) => {
      axios({ url: `${API_URL}/auth/reset-password`, data, method: 'POST' })
        .then(resp => {
          commit(USER_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['パスワードがリセットされました。'] });
          resolve(resp)
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
          commit (USER_ERROR);
          reject(err);
          Sentry.captureException(err);
        });
    });
  },
  [SET_NOTIFICATION]: ({ commit }, type, messages) => {
    commit(SET_NOTIFICATION,{ type, messages });
  },
  [USER_UPDATE]: ({ commit }, formData) => {
    commit(USER_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/users/me`, formData)
        .then(resp => {
          commit(USER_SUCCESS);
          commit(SET_PROFILE_DATA, resp.data);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['アカウント情報が更新されました。'] });
          resolve(resp);
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: [err.response.data.message] });
          commit (USER_ERROR);
          reject(err);
          Sentry.captureException(err);
        })
    })
  },
  [UPDATE_PASSWORD]: ({ commit }, formData) => {
    commit(USER_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/users/me/password`, formData)
        .then(resp => {
          commit(USER_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['パスワードが更新されました。'] });
          resolve(resp);
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: [err.response.data.message] });
          commit (USER_ERROR);
          reject(err);
          Sentry.captureException(err);
        })
    })
  },
};

const mutations = {
  [USER_REQUEST]: state => {
    state.status = 'loading';
  },
  [USER_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [SET_PROFILE_DATA]: (state, payload) => {
    Vue.set(state, "profile", payload);
  },
  [USER_ERROR]: state => {
    state.status = 'error';
  },
  [AUTH_LOGOUT]: state => {
    state.profile = null;
  },
  [SET_NOTIFICATION]: (state, payload) => {
    state.notification = { type: null, messages: [] };
    if(payload.type) {
      state.notification = payload;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
